/**
 * Nodes that have real items + a working `generate()` case, but no bespoke
 * skill-drill screen that can present their exercise type. They are drilled
 * through the generic renderer-protocol "topic drill" screen (`/exercise/topic/:nodeId`
 * on web, `/(tabs)/exercise/topic` on mobile), seeded from `expandNode(node)`.
 *
 * These stay under their parent skills in `EXERCISE_SKILL_NODES` for coach/FSRS
 * routing — this marker only governs the standalone-drill entry point.
 */
export const TOPIC_DRILL_NODES = [
  "chromatic-degrees-major",
  "chromatic-intervals",
  "slash-chords",
  "secondary-dominant-recognition",
  "modulation-recognition",
] as const;

export type TopicDrillNodeId = (typeof TOPIC_DRILL_NODES)[number];

export function isTopicDrillNode(nodeId: string): boolean {
  return (TOPIC_DRILL_NODES as readonly string[]).includes(nodeId);
}
